var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 469,
    height: 452,
    viewBox: "0 0 469 452",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M433.92 234.46C433.92 313.358 391.717 382.398 328.654 420.238C304.665 429.401 278.629 434.42 251.42 434.42C131.85 434.42 34.9199 337.49 34.9199 217.92C34.9199 139.023 77.123 69.9825 140.186 32.1425C164.175 22.9794 190.211 17.9602 217.42 17.9602C336.99 17.9602 433.92 114.891 433.92 234.46ZM0.919922 234.46C0.919922 144.128 56.243 66.7165 134.856 34.2604C74.1783 72.8512 33.9199 140.684 33.9199 217.92C33.9199 338.042 131.298 435.42 251.42 435.42C276.759 435.42 301.087 431.087 323.701 423.121C292.306 440.846 256.044 450.96 217.42 450.96C97.8503 450.96 0.919922 354.03 0.919922 234.46ZM145.138 29.2593C176.534 11.5347 212.796 1.42041 251.42 1.42041C370.99 1.42041 467.92 98.3508 467.92 217.92C467.92 308.253 412.597 385.664 333.984 418.12C394.662 379.529 434.92 311.696 434.92 234.46C434.92 114.338 337.542 16.9602 217.42 16.9602C192.08 16.9602 167.753 21.2934 145.138 29.2593Z",
    stroke: "#B6B6B6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRings);
export default __webpack_public_path__ + "static/media/rings.fdda5ec9943060b5ebcbb73c313e775c.svg";
export { ForwardRef as ReactComponent };